
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Animation`}</h1>
<p>{`Here are some examples using the different animation and animated components found in the component kit, namely `}<a parentName="p" {...{
        "href": "/component-kit/components/animated-item"
      }}><inlineCode parentName="a">{`AnimatedItem`}</inlineCode></a>{`, `}<a parentName="p" {...{
        "href": "/component-kit/layout/flex"
      }}><inlineCode parentName="a">{`Flex`}</inlineCode></a>{` and `}<a parentName="p" {...{
        "href": "/component-kit/layout/grid"
      }}><inlineCode parentName="a">{`Grid`}</inlineCode></a>{`.`}</p>
<p>{`Patterns:`}</p>
<ul>
<li parentName="ul"><a parentName="li" {...{
          "href": "/component-kit/animation/dashboard-grid"
        }}>{`Dashboard grid`}</a>{` - uses animated `}<inlineCode parentName="li">{`Grid`}</inlineCode>{`, animated `}<inlineCode parentName="li">{`Flex`}</inlineCode>{` and `}<inlineCode parentName="li">{`AnimatedItem`}</inlineCode></li>
<li parentName="ul"><a parentName="li" {...{
          "href": "/component-kit/animation/toolbar"
        }}>{`Toolbar with profiles`}</a>{` - uses animated `}<inlineCode parentName="li">{`Flex`}</inlineCode>
{/* - [Panel with rows and a sidebar](/component-kit/animation/rows-and-sidebar) - uses animated `Flex` and `AnimatedItem` */}
</li>
<li parentName="ul"><a parentName="li" {...{
          "href": "/component-kit/animation/route-changes"
        }}>{`Animation between route changes`}</a>{` - uses `}<inlineCode parentName="li">{`AnimatedItem`}</inlineCode>{` with `}<inlineCode parentName="li">{`AnimationGroup`}</inlineCode>{` + `}<inlineCode parentName="li">{`animateExit`}</inlineCode></li>
</ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;